import './App.css';
import ToDoList from './components/ToDoList';
import 'bootstrap/dist/css/bootstrap.css'

function App() {
  return (
    <div className="App">
      <ToDoList />
    </div>
  );
}

export default App;
